import type {Dispatch, GetState, ThunkAction} from 'src/reducers';
import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';

import {key, fetching} from 'src/utils/redux';
import type {JOB_POSITION} from 'src/types/crm';


const API_PATH: ApiOptions = {
  apiPath: '/trmapi',
};

const API_POST_PATH: ApiPostOptions = {
  apiPath: '/trmapi',
};
export const GET_JOB_POSITIONS = 'get-job-positions';
export const EDIT_JOB_POSITION = 'edit-job-position';
export const ADD_JOB_POSITION = 'add-job-position';

export type CrmJobPositionActions =
  | GetJobPositionsMappingAction
  | EditJobPostionMappingAction;

export type GetJobPositionsMappingAction = {
  type: typeof GET_JOB_POSITIONS;
  payload: JOB_POSITION[];
};

export type EditJobPostionMappingAction = {
  type: typeof EDIT_JOB_POSITION;
  payload: JOB_POSITION;
};

export type AddJobPostionMappingAction = {
  type: typeof ADD_JOB_POSITION;
  payload: JOB_POSITION;
};

export const setJobPositions = (
  jobPositions: JOB_POSITION[],
): GetJobPositionsMappingAction => ({
  type: GET_JOB_POSITIONS,
  payload: jobPositions,
});

export const editJobPosition = (
  jobPosition: JOB_POSITION,
): EditJobPostionMappingAction => ({
  type: EDIT_JOB_POSITION,
  payload: jobPosition,
});

export const addJobPostion = (
  jobPosition: JOB_POSITION,
): AddJobPostionMappingAction => ({
  type: ADD_JOB_POSITION,
  payload: jobPosition,
});

export const getJobPositions: (jobId: number) => ThunkAction<void> = flow(
  key((jobId) => `crm/job-positions/${jobId}`),
  fetching(),
)((jobId) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.get(`/api/job-position?jobId=${jobId}`, {}, API_PATH),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: JOB_POSITION[]) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: JOB_POSITION[]) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(setJobPositions(response));
    },
    (error) => {
      // Error handling
    },
  );
});

export const addJobPosition: (
  jobId: number,
  aopYear: number,
) => ThunkAction<void> = flow(
  key((jobId) => `crm/add-job-positions/${jobId}`),
  fetching(),
)((jobId, aopYear) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/job-position?jobId=${jobId}`,
      {
        aopYear,
      },
      {},
      API_POST_PATH,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: JOB_POSITION) => any' is not assignable to parameter of type '(value: unknown) => any'.
    (response: JOB_POSITION) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return dispatch(addJobPostion(response));
    },
    (error) => {
      // Error handling
    },
  );
});
